export const getBanners = ({ bannerReducer: { banners = [] } = {} }) => banners;
export const getBannerFilter = ({ bannerReducer: { filter = {} } = {} }) =>
  filter;
export const getBannerCount = ({ bannerReducer: { count = 0 } = {} }) => count;
export const getScheduleEventFilter = ({
  bannerReducer: { schedule_event_filter = {} } = {},
}) => schedule_event_filter;
export const getBlogFilter = ({ bannerReducer: { blog_filter = {} } = {} }) =>
  blog_filter;
